<template>
  <div class="mymoney">
    <div class="headerbox">
      <top-nav ref="TopNav"></top-nav>
      <!--<van-nav-bar title="" left-arrow @click-left="goBack" @click-right="onClickRight">-->
        <!--<van-icon slot="right" class="iconfont icon-zhankai"></van-icon>-->
      <!--</van-nav-bar>-->
      <div class="mymoneyhead">
        <div class="mymoneyheadjifen"><van-icon style="font-size: 35px" slot="right" class="iconfont goldicon icon-goldicon col-fff"></van-icon>{{ userConfig.points_usable }} {{ configData.integral_name }}</div>
        <van-row class="bottom">
          <van-col span="12" style="border-right: 1px solid #fff">累计{{ configData.integral_name }}：{{ userConfig.points_total }}</van-col>
          <van-col span="12">消耗{{ configData.integral_name }}：{{ userConfig.points_total - userConfig.points_usable }}</van-col>
        </van-row>
      </div>
      <van-tabs v-model="active" @click="vantabPlay">
        <van-tab v-for="index in 3" :title="index == 1? '全部' : index == 2? '收入' : index == 3? '支出' : ''" :key="index">
          <!--<div slot="title">{{ index == 1? '交易物流' : index == 2? '通知' : index == 3? '互动' : ''}}</div>-->
        </van-tab>
      </van-tabs>
    </div>

    <div class="van-content">
      <div class="nodata text-cent" v-if="finished && datas == ''">
        <P class="imgbox">
          <img src="/static/images/nodataimg.png"/>
        </P>
        <p class="text">暂无记录~</p>
      </div>
      <van-list style="margin-top: 45px" v-model="loading" :finished="finished" @load="getDatas">
        <van-cell-group>
          <router-link v-for="(items,index) in datas" :to="{path:'/user/mymoney/money',query:{id:items.id}}" tag="div" :key="items.id">
            <div class="van-cell van-hairline">
              <div class="van-cell__title">
                <span class="van-cell-text" v-if="items.fromtype==1">兑换礼品</span>
                <span class="van-cell-text" v-if="items.fromtype==2">系统发放</span>
                <span class="van-cell-text" v-if="items.fromtype==3">订单取消</span>
                <span class="van-cell-text" v-if="items.fromtype==4">系统扣除</span>
                <span class="van-cell-text" v-if="items.fromtype==7">签到送积分</span>
                <span class="van-cell-text" v-if="items.fromtype==8">后台导入</span>
                <span class="van-cell-text" v-if="items.fromtype==9">邀请好友</span>
                <span class="van-cell-text" v-if="items.fromtype==10">幸运大转盘</span>
                <div class="van-cell__label">{{ items.add_time }}</div>
              </div>
              <div class="van-cell__value"><span :class="items.type == 1 ? 'theme-col' : ''">{{ parseFloat(items.point)+parseFloat(items.bpoint) }}</span></div>
            </div>
          </router-link>
        </van-cell-group>
        <div v-if="!loading && finished && datas != ''" class="nomore"><span>已经到底了</span></div>
      </van-list>
    </div>
  </div>
</template>

<script>
  import TopNav from '@/components/topnav'
  export default {
    name: "mymoney",
    components: {
      TopNav
    },
    props:['userConfig','configData'],
    data () {
      return {
        datas:[],
        page:0,
        active:0,
        type:0,
        finished:false,
        loading:false,
      }
    },
    methods: {
      goBack: function () {
        history.back(-1);
      },
      onClickRight() {
        this.$refs.TopNav.topnavPlay()
      },
      vantabPlay (index) {
        this.datas = []
        this.type = index
        this.page = 0
        if(this.finished){
          this.finished = false
        }else{
          this.loading = true
          this.getDatas()
        }
      },
      getDatas: function () {
        var isUser = localStorage.getItem("BLHuser")
        var _this = this
        setTimeout(() => {
          this.page++;
          this.$api.post('WebApi/Member/Point/index', {token:isUser,type:this.type,p:this.page}, res => {
            if(res.data.data.datas.length == 0){
              _this.finished = true;
              _this.loading = false;
            }else{
              for (let i = 0; i < res.data.data.datas.length; i++) {
                _this.datas.push(res.data.data.datas[i]);
              }
              _this.loading = false;
            }
          })
        },50)
      },
    },
    mounted () {
      //this.getDatas()
    },
  }
</script>

<style lang="less">
  .mymoney{
    .headerbox{
      position: fixed;
      width: 100%;
      z-index: 9;
      background: linear-gradient(#ffa286,#f34546);
      .van-nav-bar{
        background-color: inherit;
        .van-nav-bar__title,.van-icon{
          color: #fff!important;
        }
      }
      .van-hairline--bottom::after{
        border-bottom-width:0;
      }
      .mymoneyhead{
        border-bottom: 10px solid #f2f2f2;
        text-align: center;
        .mymoneyheadjifen{
          padding: 75px 0 50px 0;
          color: #fff;
          font-size: 20px;
          .van-icon{
            vertical-align: inherit;
            font-size: 20px;
            margin-right: 10px;
          }
        }
        .bottom{
          padding: 10px 0;
          background: #f34546;
          div{
            font-size: 1.6rem;
            color: #fff;
          }
        }
      }
    }
    .van-content{
      padding-top: 217px;
      padding-bottom: 0;
       .van-cell-group{
         background: #fff;
       }
       .van-cell{
         border-bottom: 1px solid #f2f2f2;
       }
       .van-cell__value{
         color: #02a200;
         line-height: 38px;
       }
     }
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/mymoney/mymoney.vue